import { createFileRoute, redirect } from "@tanstack/react-router";

// Backward-compat redirect — old /prompt-use-case-types links land on the new path.
export const Route = createFileRoute("/_admin/prompt-use-case-types")({
  beforeLoad: () => {
    throw redirect({ to: "/prompt-engine/use-cases", replace: true });
  },
  component: () => null,
});
